/**
 * Canal Formulário Instantâneo / leads_retrieval.
 * Liberado desde 2026-09-08. Kill-switch: REACT_APP_META_FORM_CHANNEL=false.
 */

export const META_FORM_AVAILABLE_FROM = '2026-09-08';

/** Data de hoje em YYYY-MM-DD no fuso America/Sao_Paulo. */
export function todayInSaoPaulo() {
  try {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Sao_Paulo',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(new Date());
  } catch {
    return new Date().toISOString().slice(0, 10);
  }
}

/** true — canal liberado (data de corte já passou). */
export function isMetaFormChannelLive() {
  return true;
}

/** Scopes OAuth de formulário (novas conexões / reconexão sob demanda). */
export const META_FORM_OAUTH_SCOPES = ['pages_manage_ads', 'leads_retrieval'];

export const META_CATALOG_OAUTH_SCOPE = 'catalog_management';

/** instagram_basic no login da Meta: conecta o Instagram da Página junto com o Meta Ads. */
export const META_INSTAGRAM_BASIC_SCOPE = 'instagram_basic';

/**
 * Permissões do OAuth da Meta via Business Manager. Uma lista só para o
 * FastConnect, a tela /facebook-login e o "Continuar com Facebook" do cadastro,
 * para o token sair igual em todos.
 * catalog_management: catálogo; pages_manage_ads + leads_retrieval: formulário instantâneo.
 */
export function metaBmOAuthScopes() {
  return [
    'ads_read',
    'ads_management',
    'business_management',
    'pages_read_engagement',
    'pages_show_list',
    'whatsapp_business_management',
    'whatsapp_business_messaging',
    META_CATALOG_OAUTH_SCOPE,
    ...(isMetaFormChannelLive() ? META_FORM_OAUTH_SCOPES : []),
    META_INSTAGRAM_BASIC_SCOPE,
  ];
}

/** Conta pessoal: sem BM/WhatsApp; inclui form para quem for usar Instant Form. */
export function metaPersonalOAuthScopes() {
  return [
    'ads_read',
    'ads_management',
    'pages_read_engagement',
    'pages_show_list',
    ...(isMetaFormChannelLive() ? META_FORM_OAUTH_SCOPES : []),
    META_INSTAGRAM_BASIC_SCOPE,
  ];
}
